import { Card, Group, Stack, Title } from '@mantine/core'
import type { ReactNode } from 'react'

/**
 * A heading above a group of cards or rows, or a card's own title (UX spec §4.2): 14/20 semibold in the muted text
 * colour, with an optional trailing action such as "See all". [order] keeps the document outline right.
 */
export function SectionHeader(props: { children: ReactNode; action?: ReactNode; order?: 2 | 3 | 4 | 5; mt?: number | string }) {
  return (
    <Group justify="space-between" align="center" gap="xs" mt={props.mt} mb={8} wrap="nowrap">
      <Title order={props.order ?? 3} className="section-header">
        {props.children}
      </Title>
      {props.action}
    </Group>
  )
}

/** A titled section: a SectionHeader (a page-level h2 unless [order] says otherwise) over a Card, or over bare content when [card] is false. */
export function Section(props: { title: ReactNode; action?: ReactNode; order?: 2 | 3 | 4 | 5; card?: boolean; children: ReactNode }) {
  return (
    <Stack gap={0}>
      <SectionHeader order={props.order ?? 2} action={props.action}>
        {props.title}
      </SectionHeader>
      {props.card === false ? props.children : <Card>{props.children}</Card>}
    </Stack>
  )
}

/** A card's title (16/24 semibold), with an optional action on the right. */
export function CardTitle(props: { children: ReactNode; action?: ReactNode; order?: 2 | 3 | 4 | 5 }) {
  return (
    <Group justify="space-between" align="center" gap="xs" mb={12} wrap="wrap">
      <Title order={props.order ?? 4}>{props.children}</Title>
      {props.action}
    </Group>
  )
}
